// Helper functions to provide full localization for FAQ page and dynamic FAQ entries
// Supporting English (en), Marathi (mr), and Kannada (kn)

export const normalizeLang = (lang) => {
  if (!lang) return 'en';
  if (lang.startsWith('mr')) return 'mr';
  if (lang.startsWith('kn')) return 'kn';
  return 'en';
};

// ─── LOCALIZED CATEGORIES ───────────────────────────────────────────────────
export const getLocalizedFAQCategory = (category, lang = 'en', t) => {
  if (!category) return '';
  const currentLang = normalizeLang(lang);
  const catLower = category.trim().toLowerCase();

  if (catLower === 'all') {
    return t ? t('catAll') : (currentLang === 'mr' ? 'सर्व' : currentLang === 'kn' ? 'ಎಲ್ಲಾ' : 'All');
  }

  if (catLower === 'general' || catLower.includes('general')) {
    return currentLang === 'mr' ? 'सामान्य' : currentLang === 'kn' ? 'ಸಾಮಾನ್ಯ' : 'General';
  }

  if (catLower === 'custom orders' || catLower.includes('custom')) {
    return currentLang === 'mr' ? 'सानुकूल ऑर्डर्स' : currentLang === 'kn' ? 'ಕಸ್ಟಮ್ ಆರ್ಡರ್‌ಗಳು' : 'Custom Orders';
  }

  if (catLower === 'services' || catLower.includes('service')) {
    return currentLang === 'mr' ? 'सेवा' : currentLang === 'kn' ? 'ಸೇವೆಗಳು' : 'Services';
  }

  if (catLower === 'warranty' || catLower.includes('warranty')) {
    return currentLang === 'mr' ? 'वॉरंटी' : currentLang === 'kn' ? 'ವಾರಂಟಿ (ಖಾತರಿ)' : 'Warranty';
  }

  if (catLower === 'export' || catLower.includes('export')) {
    return currentLang === 'mr' ? 'निर्यात' : currentLang === 'kn' ? 'ರಫ್ತು' : 'Export';
  }

  if (catLower.includes('bedana') || catLower.includes('raisin')) {
    return currentLang === 'mr' ? 'बेदाणा प्रक्रिया' : currentLang === 'kn' ? 'ಬೆದಾನ ಸಂಸ್ಕರಣೆ' : 'Bedana Processing';
  }

  if (catLower.includes('wash') || catLower.includes('clean')) {
    return currentLang === 'mr' ? 'वॉशिंग आणि क्लीनिंग' : currentLang === 'kn' ? 'ತೊಳೆಯುವಿಕೆ ಮತ್ತು ಸ್ವಚ್ಛಗೊಳಿಸುವಿಕೆ' : 'Washing & Cleaning';
  }

  if (catLower.includes('grad') || catLower.includes('sort')) {
    return currentLang === 'mr' ? 'ग्रेडिंग आणि सॉर्टिंग' : currentLang === 'kn' ? 'ಗ್ರೇಡಿಂಗ್ ಮತ್ತು ವಿಂಗಡಣೆ' : 'Grading & Sorting';
  }

  if (catLower.includes('conveyor') || catLower.includes('handling')) {
    return currentLang === 'mr' ? 'कन्व्हेयर आणि हँडलिंग' : currentLang === 'kn' ? 'ಕನ್ವೇಯರ್ ಮತ್ತು ಹ್ಯಾಂಡ್ಲಿಂಗ್' : 'Conveyor & Handling';
  }

  return t ? t(category, category) : category;
};

// ─── DICTIONARY FOR KNOWN FAQS ───────────────────────────────────────────────
const FAQ_DICTIONARY = {
  // 1. What products does Digvijay Industries manufacture?
  "what products does digvijay industries manufacture": {
    mr: {
      q: "दिग्विजय इंडस्ट्रीज कोणती उत्पादने बनवते?",
      a: "दिग्विजय इंडस्ट्रीज बेदाणा प्रक्रिया मशिनरी, वॉशिंग व क्लीनिंग सिस्टीम, ग्रेडर, कन्व्हेयर, मटेरियल हँडलिंग उपकरणे आणि अन्न प्रक्रिया व कृषी क्षेत्रासाठी आवश्यक सानुकूल मशिनरीचे उत्पादन करते."
    },
    kn: {
      q: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಯಾವ ಉತ್ಪನ್ನಗಳನ್ನು ತಯಾರಿಸುತ್ತದೆ?",
      a: "ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಒಣದ್ರಾಕ್ಷಿ (ಬೇಡಾನಾ) ಸಂಸ್ಕರಣಾ ಯಂತ್ರೋಪಕರಣಗಳು, ತೊಳೆಯುವ ಮತ್ತು ಸ್ವಚ್ಛಗೊಳಿಸುವ ವ್ಯವಸ್ಥೆಗಳು, ಗ್ರೇಡರ್‌ಗಳು, ಕನ್ವೇಯರ್‌ಗಳು, ಮೆಟೀರಿಯಲ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್ ಉಪಕರಣಗಳು ಮತ್ತು ಕೃಷಿ ಹಾಗೂ ಆಹಾರ ಸಂಸ್ಕರಣಾ ಕೈಗಾರಿಕೆಗಳಿಗೆ ಅಗತ್ಯವಾದ ಕಸ್ಟಮೈಸ್ಡ್ ಯಂತ್ರಗಳನ್ನು ತಯಾರಿಸುತ್ತದೆ."
    }
  },

  // 2. Which industries use Digvijay Industries' machines?
  "which industries use digvijay industries' machines": {
    mr: {
      q: "कोणते उद्योग 'दिग्विजय इंडस्ट्रीज'च्या यंत्रांचा वापर करतात?",
      a: "आमची यंत्रसामग्री कृषी प्रक्रिया युनिट्स, अन्न प्रक्रिया उद्योग, बेदाणा प्रक्रिया प्रकल्प, सुका मेवा प्रक्रिया युनिट्स, गोदामे, पॅकेजिंग उद्योग आणि औद्योगिक मटेरियल हँडलिंगमध्ये मोठ्या प्रमाणावर वापरली जाते."
    },
    kn: {
      q: "ಯಾವ ಕೈಗಾರಿಕೆಗಳು ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್‌ನ ಯಂತ್ರಗಳನ್ನು ಬಳಸುತ್ತವೆ?",
      a: "ನಮ್ಮ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ಕೃಷಿ ಸಂಸ್ಕರಣಾ ಘಟಕಗಳು, ಆಹಾರ ಸಂಸ್ಕರಣಾ ಕೈಗಾರಿಕೆಗಳು, ಒಣದ್ರಾಕ್ಷಿ ಸಂಸ್ಕರಣಾ ಘಟಕಗಳು, ಒಣ ಹಣ್ಣು ಸಂಸ್ಕರಣಾ ಘಟಕಗಳು, ಗೋದಾಮುಗಳು, ಪ್ಯಾಕೇಜಿಂಗ್ ಕೈಗಾರಿಕೆಗಳು ಮತ್ತು ಕೈಗಾರಿಕಾ ಮೆಟೀರಿಯಲ್ ಹ್ಯಾಂಡ್ಲಿಂಗ್‌ನಲ್ಲಿ ವ್ಯಾಪಕವಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ."
    }
  },

  // 3. Can you manufacture customized machinery?
  "can you manufacture customized machinery": {
    mr: {
      q: "तुम्ही ग्राहकांच्या गरजेनुसार (कस्टमाइज्ड) मशिनरी बनवता का?",
      a: "होय, नक्कीच. आम्ही ग्राहकांच्या विशिष्ट उत्पादन क्षमता, जागेची उपलब्धता आणि कार्यप्रणालीच्या आवश्यकतांनुसार पूर्णपणे सानुकूलित (कस्टम-इंजिनिअर्ड) मशिन्स डिझाइन आणि तयार करतो."
    },
    kn: {
      q: "ನೀವು ಕಸ್ಟಮೈಸ್ ಮಾಡಿದ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ತಯಾರಿಸಬಹುದೇ?",
      a: "ಖಂಡಿತವಾಗಿ. ಗ್ರಾಹಕರ ನಿರ್ದಿಷ್ಟ ಉತ್ಪಾದನಾ ಸಾಮರ್ಥ್ಯ, ಜಾಗದ ಲಭ್ಯತೆ ಮತ್ತು ಕಾರ್ಯಾಚರಣೆಯ ಅಗತ್ಯತೆಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ನಾವು ಸಂಪೂರ್ಣ ಕಸ್ಟಮ್-ಇಂಜಿನಿಯರ್ಡ್ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ವಿನ್ಯಾಸಗೊಳಿಸುತ್ತೇವೆ ಮತ್ತು ತಯಾರಿಸುತ್ತೇವೆ."
    }
  },

  // 4. Do you provide machine installation services?
  "do you provide machine installation services": {
    mr: {
      q: "तुम्ही मशीन इन्स्टॉलेशन सेवा पुरवता का?",
      a: "होय. आमची अनुभवी तांत्रिक टीम सुरळीत आणि कार्यक्षम संचालन सुनिश्चित करण्यासाठी संपूर्ण मशीन इन्स्टॉलेशन, ट्रायल रन आणि ऑपरेटर प्रशिक्षण साइटवर जाऊन प्रदान करते."
    },
    kn: {
      q: "ನೀವು ಯಂತ್ರ ಸ್ಥಾಪನೆ ಸೇವೆಗಳನ್ನು ಒದಗಿಸುತ್ತೀರಾ?",
      a: "ಹೌದು. ನಮ್ಮ ಅನುಭವಿ ತಾಂತ್ರಿಕ ತಂಡವು ಸುಗಮ ಮತ್ತು ಪರಿಣಾಮಕಾರಿ ಕಾರ್ಯಾಚರಣೆಯನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ಸಂಪೂರ್ಣ ಯಂತ್ರ ಸ್ಥಾಪನೆ, ಪ್ರಾಯೋಗಿಕ ಪರೀಕ್ಷೆ ಮತ್ತು ಆಪರೇಟರ್ ತರಬೇತಿಯನ್ನು ಸ್ಥಳದಲ್ಲೇ ಒದಗಿಸುತ್ತದೆ."
    }
  },

  // 5. Does the warranty cover spare parts and servicing?
  "does the warranty cover spare parts and servicing": {
    mr: {
      q: "वॉरंटीमध्ये स्पेअर पार्ट्स आणि सर्व्हिसिंगचा समावेश आहे का?",
      a: "वॉरंटीमध्ये सामान्यतः लागू असलेल्या अटी व शर्तींनुसार उत्पादनाशी संबंधित दोषांचा समावेश असतो. वॉरंटी कालावधीदरम्यान किंवा त्यानंतर अस्सल स्पेअर पार्ट्स आणि नियमित सर्व्हिसिंग सपोर्ट उपलब्ध करून दिला जातो."
    },
    kn: {
      q: "ವಾರಂಟಿಯು ಬಿಡಿಭಾಗಗಳು ಮತ್ತು ಸೇವೆಯನ್ನು ಒಳಗೊಳ್ಳುತ್ತದೆಯೇ?",
      a: "ವಾರಂಟಿಯು ಸಾಮಾನ್ಯವಾಗಿ ಅನ್ವಯವಾಗುವ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳ ಅಡಿಯಲ್ಲಿ ಉತ್ಪಾದನೆಗೆ ಸಂಬಂಧಿಸಿದ ದೋಷಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ. ವಾರಂಟಿ ಅವಧಿಯಲ್ಲಿ ಅಥವಾ ನಂತರ ನಿಜವಾದ ಬಿಡಿಭಾಗಗಳು ಮತ್ತು ನಿಯಮಿತ ಸೇವಾ ಬೆಂಬಲವನ್ನು ಒದಗಿಸಲಾಗುತ್ತದೆ."
    }
  },

  // 6. Why should I choose Digvijay Industries?
  "why should i choose digvijay industries": {
    mr: {
      q: "मी दिग्विजय इंडस्ट्रीजची निवड का करावी?",
      a: "आम्ही विश्वसनीय, अचूक अभियांत्रिकीने बनवलेली यंत्रसामग्री पुरवण्यावर लक्ष केंद्रित करतो जी उत्पादकता वाढवते, देखभालीचा खर्च कमी करते आणि समर्पित ग्राहक सेवेसह उत्कृष्ट परिणाम देते."
    },
    kn: {
      q: "ನಾನು ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಅನ್ನು ಏಕೆ ಆರಿಸಬೇಕು?",
      a: "ಉತ್ಪಾದಕತೆಯನ್ನು ಸುಧಾರಿಸುವ, ನಿರ್ವಹಣಾ ಅವಶ್ಯಕತೆಗಳನ್ನು ಕಡಿಮೆ ಮಾಡುವ ಮತ್ತು ಸಮರ್ಪಿತ ಗ್ರಾಹಕ ಬೆಂಬಲದೊಂದಿಗೆ ಅತ್ಯುತ್ತಮ ಫಲಿತಾಂಶಗಳನ್ನು ನೀಡುವ ವಿಶ್ವಾಸಾರ್ಹ, ನಿಖರ-ಎಂಜಿನಿಯರ್ಡ್ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ತಲುಪಿಸಲು ನಾವು ಬದ್ಧರಾಗಿದ್ದೇವೆ."
    }
  },

  // 7. Can you help us select the right machine?
  "can you help us select the right machine": {
    mr: {
      q: "तुम्ही आम्हाला योग्य मशीन निवडण्यात मदत करू शकाल का?",
      a: "नक्कीच. आमचे तज्ञ तुमच्या व्यवसायासाठी सर्वात योग्य यंत्रसामग्रीची शिफारस करण्यासाठी तुमच्या प्रक्रिया आवश्यकता, उत्पादन क्षमता आणि बजेट समजून घेऊन योग्य मार्गदर्शन करतात."
    },
    kn: {
      q: "ಸರಿಯಾದ ಯಂತ್ರವನ್ನು ಆಯ್ಕೆ ಮಾಡಲು ನೀವು ನಮಗೆ ಸಹಾಯ ಮಾಡಬಹುದೇ?",
      a: "ಖಂಡಿತ. ನಿಮ್ಮ ವ್ಯವಹಾರಕ್ಕೆ ಹೆಚ್ಚು ಸೂಕ್ತವಾದ ಯಂತ್ರೋಪಕರಣಗಳ ಪರಿಹಾರವನ್ನು ಶಿಫಾರಸು ಮಾಡಲು ನಮ್ಮ ತಜ್ಞರು ನಿಮ್ಮ ಸಂಸ್ಕರಣಾ ಅಗತ್ಯತೆಗಳು, ಉತ್ಪಾದನಾ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಬಜೆಟ್ ಅನ್ನು ಅರ್ಥಮಾಡಿಕೊಂಡು ಮಾರ್ಗದರ್ಶನ ನೀಡುತ್ತಾರೆ."
    }
  },

  // 8. Do you provide spare parts and after-sales support?
  "do you provide spare parts and after-sales support": {
    mr: {
      q: "तुम्ही स्पेअर पार्ट्स आणि विक्रीनंतरची सेवा पुरवता का?",
      a: "होय. मशीनची कार्यक्षमता वाढवण्यासाठी आणि डाउनटाइम कमी करण्यासाठी आम्ही अस्सल स्पेअर पार्ट्स, प्रतिबंधात्मक देखभालीसाठी मदत, तांत्रिक समस्यानिवारण आणि विश्वसनीय विक्रीनंतरची सेवा देतो."
    },
    kn: {
      q: "ನೀವು ಬಿಡಿಭಾಗಗಳು ಮತ್ತು ಮಾರಾಟದ ನಂತರದ ಬೆಂಬಲವನ್ನು ಒದಗಿಸುತ್ತೀರಾ?",
      a: "ಹೌದು. ಯಂತ್ರದ ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ಮತ್ತು ಡೌನ್‌ಟೈಮ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡಲು ನಾವು ನಿಜವಾದ ಬಿಡಿಭಾಗಗಳು, ತಡೆಗಟ್ಟುವ ನಿರ್ವಹಣಾ ಸಹಾಯ, ತಾಂತ್ರಿಕ ದೋಷನಿವಾರಣೆ ಮತ್ತು ವಿಶ್ವಾಸಾರ್ಹ ಮಾರಾಟದ ನಂತರದ ಬೆಂಬಲವನ್ನು ನೀಡುತ್ತೇವೆ."
    }
  },

  // 9. Can you manage export documentation and shipping?
  "can you manage export documentation and shipping": {
    mr: {
      q: "तुम्ही निर्यातीची कागदपत्रे आणि शिपिंगचे व्यवस्थापन करू शकता का?",
      a: "होय. यंत्रसामग्री ग्राहकांपर्यंत सुरक्षितपणे आणि कार्यक्षमतेने पोहोचावी यासाठी आम्ही निर्यातीची कागदपत्रे, शिपमेंट समन्वय, पॅकेजिंग आणि लॉजिस्टिक्स सहाय्य पुरवतो."
    },
    kn: {
      q: "ರಫ್ತು ದಸ್ತಾವೇಜನ್ನು ಮತ್ತು ಸಾಗಣೆಯನ್ನು ನೀವು ನಿರ್ವಹಿಸಬಹುದೇ?",
      a: "ಹೌದು. ಯಂತ್ರೋಪಕರಣಗಳು ಗ್ರಾಹಕರನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಮತ್ತು ಪರಿಣಾಮಕಾರಿಯಾಗಿ ತಲುಪುವುದನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಲು ನಾವು ರಫ್ತು ದಸ್ತಾವೇಜನ್ನು, ಸಾಗಣೆ ಸಮನ್ವಯ, ಪ್ಯಾಕೇಜಿಂಗ್ ಮತ್ತು ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಬೆಂಬಲದೊಂದಿಗೆ ಸಹಾಯ ಮಾಡುತ್ತೇವೆ."
    }
  },

  // 10. Do you export machinery outside India?
  "do you export machinery outside india": {
    mr: {
      q: "तुम्ही भारताबाहेर यंत्रसामग्री निर्यात करता का?",
      a: "होय. दिग्विजय इंडस्ट्रीज आंतरराष्ट्रीय ग्राहकांना निर्यातीसाठी तयार यंत्रसामग्री, सुरक्षित पॅकेजिंग, निर्यात कागदपत्रे आणि परदेशात सुरळीत वितरणासाठी लॉजिस्टिक्स सहाय्य पुरवते."
    },
    kn: {
      q: "ನೀವು ಭಾರತದ ಹೊರಗೆ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ರಫ್ತು ಮಾಡುತ್ತೀರಾ?",
      a: "ಹೌದು. ದಿಗ್ವಿಜಯ್ ಇಂಡಸ್ಟ್ರೀಸ್ ಸುರಕ್ಷಿತ ಪ್ಯಾಕೇಜಿಂಗ್, ರಫ್ತು ದಸ್ತಾವೇಜೀಕರಣ ಮತ್ತು ಸುಗಮ ವಿದೇಶ ವಿತರಣೆಗಾಗಿ ಲಾಜಿಸ್ಟಿಕ್ಸ್ ಸಹಾಯದೊಂದಿಗೆ ರಫ್ತು-ಸಿದ್ಧ ಯಂತ್ರೋಪಕರಣಗಳನ್ನು ಒದಗಿಸುವ ಮೂಲಕ ಅಂತರರಾಷ್ಟ್ರೀಯ ಗ್ರಾಹಕರನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ."
    }
  },

  // 11. Do your machines come with a warranty?
  "do your machines come with a warranty": {
    mr: {
      q: "तुमच्या यंत्रांवर वॉरंटी आहे का?",
      a: "होय. आमच्या यंत्रसामग्रीवर उत्पादन दोषांविरुद्ध वॉरंटीचे संरक्षण दिले जाते. वॉरंटीच्या अटी यंत्राचे मॉडेल आणि प्रकल्पाच्या वैशिष्ट्यांनुसार बदलू शकतात."
    },
    kn: {
      q: "ನಿಮ್ಮ ಯಂತ್ರಗಳಿಗೆ ಖಾತರಿ ಇದೆಯೇ?",
      a: "ಹೌದು. ನಮ್ಮ ಯಂತ್ರಗಳಿಗೆ ಉತ್ಪಾದನಾ ದೋಷಗಳ ವಿರುದ್ಧ ಖಾತರಿ ಕವರೇಜ್ ಒದಗಿಸಲಾಗಿದೆ. ಯಂತ್ರದ ಮಾದರಿ ಮತ್ತು ಯೋಜನೆಯ ವಿಶೇಷಣಗಳನ್ನು ಅವಲಂಬಿಸಿ ಖಾತರಿ ನಿಯಮಗಳು ಬದಲಾಗಬಹುದು."
    }
  },

  // 12. Can I request modifications to an existing machine?
  "can i request modifications to an existing machine": {
    mr: {
      q: "मी एखाद्या जुन्या मशीनमध्ये बदल करण्याची विनंती करू शकतो का?",
      a: "नक्कीच. तुमच्या विशिष्ट औद्योगिक गरजा पूर्ण करण्यासाठी आमची अभियांत्रिकी टीम मशीनचे आकारमान, क्षमता, ऑटोमेशनची वैशिष्ट्ये आणि कार्यप्रवाहाची रचना (workflow configurations) यामध्ये आवश्यक ते बदल करून देऊ शकते."
    },
    kn: {
      q: "ಹಳೆಯ ಯಂತ್ರಕ್ಕೆ ಮಾರ್ಪಾಡುಗಳನ್ನು ನಾನು ವಿನಂತಿಸಬಹುದೇ?",
      a: "ಖಂಡಿತ. ನಮ್ಮ ಎಂಜಿನಿಯರಿಂಗ್ ತಂಡವು ನಿಮ್ಮ ನಿರ್ದಿಷ್ಟ ಕೈಗಾರಿಕಾ ಅವಶ್ಯಕತೆಗಳನ್ನು ಪೂರೈಸಲು ಯಂತ್ರದ ಆಯಾಮಗಳು, ಸಾಮರ್ಥ್ಯ, ಯಾಂತ್ರೀಕೃತಗೊಂಡ ವೈಶಿಷ್ಟ್ಯಗಳು ಮತ್ತು ಕೆಲಸದ ಹರಿವಿನ ಸಂರಚನೆಗಳನ್ನು ಕಸ್ಟಮೈಸ್ ಮಾಡಬಹುದು."
    }
  }
};

// Match against dictionary keys
const findDictionaryEntry = (question) => {
  if (!question) return null;
  const cleanQ = question.toLowerCase().replace(/[^a-z0-9 ]/g, '').trim();
  for (const [key, val] of Object.entries(FAQ_DICTIONARY)) {
    if (cleanQ.includes(key) || key.includes(cleanQ)) {
      return val;
    }
  }
  return null;
};

// ─── LOCALIZED QUESTION ─────────────────────────────────────────────────────
export const getLocalizedFAQQuestion = (faq, lang = 'en') => {
  if (!faq) return '';
  const currentLang = normalizeLang(lang);
  if (currentLang === 'en') return faq.question || '';

  // 1. Check direct field on FAQ object
  if (currentLang === 'mr' && (faq.question_mr || faq.questionMr)) {
    return faq.question_mr || faq.questionMr;
  }
  if (currentLang === 'kn' && (faq.question_kn || faq.questionKn)) {
    return faq.question_kn || faq.questionKn;
  }

  // 2. Check dictionary
  const dict = findDictionaryEntry(faq.question);
  if (dict && dict[currentLang]?.q) {
    return dict[currentLang].q;
  }

  // 3. Check client-side cached translation
  try {
    const cacheKey = `faq_trans_${currentLang}_${encodeURIComponent((faq.question || '').trim())}`;
    const cached = localStorage.getItem(cacheKey);
    if (cached) return cached;
  } catch (e) {}

  return faq.question || '';
};

// ─── LOCALIZED ANSWER ───────────────────────────────────────────────────────
export const getLocalizedFAQAnswer = (faq, lang = 'en') => {
  if (!faq) return '';
  const currentLang = normalizeLang(lang);
  if (currentLang === 'en') return faq.answer || '';

  // 1. Check direct field on FAQ object
  if (currentLang === 'mr' && (faq.answer_mr || faq.answerMr)) {
    return faq.answer_mr || faq.answerMr;
  }
  if (currentLang === 'kn' && (faq.answer_kn || faq.answerKn)) {
    return faq.answer_kn || faq.answerKn;
  }

  // 2. Check dictionary
  const dict = findDictionaryEntry(faq.question);
  if (dict && dict[currentLang]?.a) {
    return dict[currentLang].a;
  }

  // 3. Check client-side cached translation
  try {
    const cacheKey = `faq_trans_${currentLang}_${encodeURIComponent((faq.answer || '').trim())}`;
    const cached = localStorage.getItem(cacheKey);
    if (cached) return cached;
  } catch (e) {}

  return faq.answer || '';
};

// ─── ON-DEMAND AUTO TRANSLATION HELPER ──────────────────────────────────────
// Translates any text from English to target language (mr / kn)
export const translateFAQText = async (text, targetLang) => {
  if (!text || !targetLang || targetLang === 'en') return text;
  const lang = normalizeLang(targetLang);
  if (lang === 'en') return text;

  const cacheKey = `faq_trans_${lang}_${encodeURIComponent(text.trim())}`;
  try {
    const cached = localStorage.getItem(cacheKey);
    if (cached) return cached;
  } catch (e) {}

  try {
    const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=en|${lang}`;
    const res = await fetch(url);
    const data = await res.json();
    if (data && data.responseData && data.responseData.translatedText) {
      const translated = data.responseData.translatedText;
      try {
        localStorage.setItem(cacheKey, translated);
      } catch (e) {}
      return translated;
    }
  } catch (err) {
    console.warn('Auto translation request failed:', err);
  }

  return text;
};
